import { motion } from 'framer-motion';
import { useGameStore } from '../stores/gameStore';
import { playClick, playMenuBeep, playMoveBeep } from '../utils/audio';
import { GameCanvas } from './GameCanvas';
import { BounceCanvas } from './BounceCanvas';
import { BrickCanvas } from './BrickCanvas';
import { GameOver } from './GameOver';
import { LevelSelect } from './LevelSelect';
import { Settings } from './Settings';

const GamesMenuLCD = () => {
  const {
    openSnakeFromMenu,
    openBounceFromMenu,
    openBrickFromMenu,
    goToHighScores
  } = useGameStore();

  return (
    <div className="lcd-games">
      <div className="lcd-games-title">GAMES</div>
      <div className="games-grid">
        <motion.button
          className="game-icon-tile"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => {
            playMoveBeep();
            openSnakeFromMenu();
          }}
        >
          <div className="game-icon-symbol">🐍</div>
          <div className="game-icon-label">Snake</div>
        </motion.button>

        <motion.button
          className="game-icon-tile"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => {
            playMoveBeep();
            openBounceFromMenu();
          }}
        >
          <div className="game-icon-symbol">⚽</div>
          <div className="game-icon-label">Bounce</div>
        </motion.button>

        <motion.button
          className="game-icon-tile"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => {
            playMoveBeep();
            openBrickFromMenu();
          }}
        >
          <div className="game-icon-symbol">▧</div>
          <div className="game-icon-label">Brick</div>
        </motion.button>

        <motion.button
          className="game-icon-tile small"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => {
            playClick();
            openSnakeFromMenu();
            goToHighScores();
          }}
        >
          <div className="game-icon-symbol">★</div>
          <div className="game-icon-label">Stats</div>
        </motion.button>

        <motion.button
          className="game-icon-tile small"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => {
            playClick();
            useGameStore.getState().openSettings();
          }}
        >
          <div className="game-icon-symbol">⚙</div>
          <div className="game-icon-label">Settings</div>
        </motion.button>
      </div>
    </div>
  );
};

const SnakeMenuLCD = () => {
  const { startGame, goToLevelSelect, goToHighScores, openSettings } = useGameStore();

  return (
    <div className="lcd-menu">
      <h1 className="nokia-title">SNAKE</h1>
      <div className="nokia-subtitle">Nostalgia</div>
      <div className="menu-list">
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playMenuBeep();
            startGame();
          }}
        >
          Start Game
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            goToLevelSelect();
          }}
        >
          Select Level
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            goToHighScores();
          }}
        >
          High Scores
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            openSettings();
          }}
        >
          Settings
        </motion.button>
      </div>
    </div>
  );
};

const HighScoresLCD = () => {
  const { bestScoreAllTime, bestScoreToday, totalGamesPlayed, goToMenu } = useGameStore();

  return (
    <div className="lcd-menu">
      <h2 className="nokia-title">HIGH SCORES</h2>
      <div className="score-list">
        <div className="score-row">
          <span>Best All Time:</span>
          <span>{bestScoreAllTime.toString().padStart(4, '0')}</span>
        </div>
        <div className="score-row">
          <span>Best Today:</span>
          <span>{bestScoreToday.toString().padStart(4, '0')}</span>
        </div>
        <div className="score-row">
          <span>Games Played:</span>
          <span>{totalGamesPlayed}</span>
        </div>
      </div>
      <motion.button
        className="back-btn"
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          playClick();
          goToMenu();
        }}
      >
        ← Back
      </motion.button>
    </div>
  );
};

const BounceMenuLCD = () => {
  const { bounceStart, openGamesMenu } = useGameStore();

  return (
    <div className="lcd-menu">
      <h1 className="nokia-title">BOUNCE</h1>
      <div className="nokia-subtitle">Ball Classic</div>
      <div className="menu-list">
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => bounceStart()}
        >
          Start
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => bounceStart(2)}
        >
          Level 2
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => bounceStart(3)}
        >
          Level 3
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            openGamesMenu();
          }}
        >
          Back
        </motion.button>
      </div>
    </div>
  );
};

const BounceGameOverLCD = () => {
  const { bounce, bounceStart, bounceBackToMenu } = useGameStore();

  return (
    <div className="lcd-menu">
      <div className="gameover-title">GAME OVER</div>
      <div className="final-score">{bounce.score.toString().padStart(4, '0')}</div>
      <div className="score-details">
        <div>BEST: {bounce.bestScore.toString().padStart(4, '0')}</div>
        <div>LEVEL: {bounce.level}</div>
      </div>
      <div className="action-buttons">
        <motion.button
          className="restart-btn nokia-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            bounceStart(bounce.level);
          }}
        >
          🔄 PLAY AGAIN
        </motion.button>
        <motion.button
          className="back-btn"
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            bounceBackToMenu();
          }}
        >
          ← Back
        </motion.button>
      </div>
    </div>
  );
};

const BrickMenuLCD = () => {
  const { brickStart, openGamesMenu } = useGameStore();

  return (
    <div className="lcd-menu">
      <h1 className="nokia-title">BRICK</h1>
      <div className="nokia-subtitle">Breaker Retro</div>
      <div className="menu-list">
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => brickStart(1)}
        >
          Level 1
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => brickStart(2)}
        >
          Level 2
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => brickStart(3)}
        >
          Level 3
        </motion.button>
        <motion.button
          className="menu-item"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            openGamesMenu();
          }}
        >
          Back
        </motion.button>
      </div>
    </div>
  );
};

const BrickGameOverLCD = () => {
  const { brick, brickStart, brickBackToMenu } = useGameStore();

  return (
    <div className="lcd-menu">
      <div className="gameover-title">GAME OVER</div>
      <div className="final-score">{brick.score.toString().padStart(4, '0')}</div>
      <div className="score-details">
        <div>BEST: {brick.bestScore.toString().padStart(4, '0')}</div>
        <div>LEVEL: {brick.level}</div>
      </div>
      <div className="action-buttons">
        <motion.button
          className="restart-btn nokia-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            brickStart(brick.level);
          }}
        >
          🔄 PLAY AGAIN
        </motion.button>
        <motion.button
          className="back-btn"
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            playClick();
            brickBackToMenu();
          }}
        >
          ← Back
        </motion.button>
      </div>
    </div>
  );
};

export const NokiaPhone = () => {
  const {
    appScreen,
    currentGame,
    phase,
    bounce,
    brick,
    setDirection,
    pause,
    resume,
    startGame,
    goToMenu,
    goToLevelSelect,
    openSettings
  } = useGameStore();

  const handleDirection = (dir: 'up' | 'down' | 'left' | 'right') => {
    // Only play beep occasionally to avoid noise (Snake moves continuously)
    if (Math.random() < 0.1) {
      playMoveBeep();
    }
    if ('vibrate' in navigator) navigator.vibrate(10);
    if (currentGame === 'snake') {
      setDirection(dir);
    } else if (currentGame === 'bounce') {
      if (dir === 'left' || dir === 'right') {
        useGameStore.getState().bounceMove(dir);
      }
    } else if (currentGame === 'brick') {
      if (dir === 'left' || dir === 'right') {
        useGameStore.getState().brickMove(dir);
      }
    }
  };

  const handleGreenButton = () => {
    playClick();
    if ('vibrate' in navigator) navigator.vibrate(20);
    if (phase === 'menu' || phase === 'gameOver') {
      startGame();
    } else if (phase === 'playing') {
      goToMenu();
      setTimeout(() => startGame(), 100);
    }
  };

  const handleRedButton = () => {
    playClick();
    if ('vibrate' in navigator) navigator.vibrate(20);
    if (phase === 'playing') {
      pause();
    } else if (phase === 'paused') {
      goToMenu();
    }
  };

  const handleOKButton = () => {
    playClick();
    if ('vibrate' in navigator) navigator.vibrate(20);
    if (phase === 'playing') {
      pause();
    } else if (phase === 'paused') {
      resume();
    }
  };

  // Soft-key labels: simple and consistent
  const leftSoftKeyLabel =
    appScreen === 'gamesMenu' ? 'Select' : phase === 'menu' ? 'Select' : 'OK';
  const rightSoftKeyLabel = 'Back';

  return (
    <div className="nokia-phone">
      {/* Status Bar */}
      <div className="nokia-status-bar">
        <div className="status-signal">▂▃▅▇</div>
        <div className="status-time">12:34</div>
        <div className="status-battery">▮▮▮</div>
      </div>

      {/* Screen Area (inner bezel + soft-key labels) */}
      <div className="nokia-screen">
        <div className="nokia-screen-inner">
          {appScreen === 'gamesMenu' ? (
            <GamesMenuLCD />
          ) : appScreen === 'settings' ? (
            <Settings />
          ) : appScreen === 'game' && currentGame === 'snake' && phase === 'menu' ? (
            <SnakeMenuLCD />
          ) : appScreen === 'game' && currentGame === 'snake' && phase === 'levelSelect' ? (
            <LevelSelect />
          ) : appScreen === 'game' && currentGame === 'snake' && phase === 'highScores' ? (
            <HighScoresLCD />
          ) : appScreen === 'game' && currentGame === 'bounce' && bounce.phase === 'menu' ? (
            <BounceMenuLCD />
          ) : appScreen === 'game' && currentGame === 'bounce' && bounce.phase === 'gameOver' ? (
            <BounceGameOverLCD />
          ) : appScreen === 'game' && currentGame === 'brick' && brick.phase === 'menu' ? (
            <BrickMenuLCD />
          ) : appScreen === 'game' && currentGame === 'brick' && brick.phase === 'gameOver' ? (
            <BrickGameOverLCD />
          ) : currentGame === 'bounce' ? (
            <BounceCanvas />
          ) : currentGame === 'brick' ? (
            <BrickCanvas />
          ) : (
            <GameCanvas />
          )}
          {/* Snake GameOver overlay rendered inside LCD so it stays within phone */}
          {currentGame === 'snake' && phase === 'gameOver' && <GameOver />}
        </div>
        <div className="softkey-label-row">
          <span className="softkey-label left">{leftSoftKeyLabel}</span>
          <span className="softkey-label right">{rightSoftKeyLabel}</span>
        </div>
      </div>

      {/* Button Area */}
      <div className="nokia-buttons">
        {/* Physical soft keys (map to labels under screen) */}
        <div className="soft-keys">
          <motion.button
            className="soft-key left"
            whileTap={{ scale: 0.96 }}
            onClick={() => {
              playClick();
              // Left soft key acts like OK/Select depending on screen
              if (appScreen === 'gamesMenu') {
                // In games menu we treat left soft as same as tapping current highlighted item;
                // for now default to Snake.
                useGameStore.getState().openSnakeFromMenu();
              } else if (appScreen === 'game' && currentGame === 'snake') {
                if (phase === 'menu') {
                  useGameStore.getState().startGame();
                } else if (phase === 'levelSelect') {
                  goToMenu();
                }
              }
            }}
          />
          <motion.button
            className="soft-key right"
            whileTap={{ scale: 0.96 }}
            onClick={() => {
              playClick();
              // Right soft key is global Back
              const store = useGameStore.getState();
              if (store.appScreen === 'game') {
                store.openGamesMenu();
              } else {
                store.openGamesMenu();
              }
            }}
          />
        </div>

        {/* D-Pad */}
        <div className="dpad-container">
          <div className="dpad">
            <motion.button
              className="dpad-btn up"
              whileTap={{ scale: 0.9 }}
              onPointerDown={(e) => {
                e.preventDefault();
                handleDirection('up');
              }}
            >
              ▲
            </motion.button>
            <div className="dpad-middle">
              <motion.button
                className="dpad-btn left"
                whileTap={{ scale: 0.9 }}
                onPointerDown={(e) => {
                  e.preventDefault();
                  handleDirection('left');
                }}
                onPointerUp={(e) => {
                  e.preventDefault();
                  if (currentGame === 'bounce') {
                    useGameStore.getState().bounceMove('none');
                  }
                }}
              >
                ◀
              </motion.button>
              <motion.button
                className="dpad-center"
                whileTap={{ scale: 0.94 }}
                onClick={handleOKButton}
              >
                OK
              </motion.button>
              <motion.button
                className="dpad-btn right"
                whileTap={{ scale: 0.9 }}
                onPointerDown={(e) => {
                  e.preventDefault();
                  handleDirection('right');
                }}
                onPointerUp={(e) => {
                  e.preventDefault();
                  if (currentGame === 'bounce') {
                    useGameStore.getState().bounceMove('none');
                  }
                }}
              >
                ▶
              </motion.button>
            </div>
            <motion.button
              className="dpad-btn down"
              whileTap={{ scale: 0.9 }}
              onPointerDown={(e) => {
                e.preventDefault();
                handleDirection('down');
              }}
            >
              ▼
            </motion.button>
          </div>
        </div>

        {/* Green / Red keys */}
        <div className="action-buttons-row">
          <motion.button
            className="nokia-btn green"
            whileTap={{ scale: 0.94 }}
            onClick={handleGreenButton}
          >
            ☎
          </motion.button>
          <motion.button
            className="nokia-btn red"
            whileTap={{ scale: 0.94 }}
            onClick={handleRedButton}
          >
            ⏻
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default NokiaPhone;


